import { Icon } from "@ui/Icon";
import askGVTLogo from "@ui/icons/AskGVTLogo.svg?raw";
import { HStack, Stack } from "@ui/Stack";
import { Text } from "@ui/typography/Text";
import { askPageVars } from "../pageVars";

export const AskFooter = () => {
	const vars = askPageVars();

	return (
		<footer class="askgvt1-footer">
			<Stack
				class="askgvt1-footer-inner"
				direction="row"
				align="center"
				justify="space-between"
				spacing="large"
				wrap
				fullWidth
			>
				<HStack align="center" spacing="large" grow>
					<Icon
						icon={askGVTLogo}
						class="askgvt1-footer-logo"
						fillWithCurrentColor={false}
						display="inline-flex"
					/>
					<Text size="small" color="fg2">
						{`Every answer on this page is grounded in ${vars.influencer_display_name}'s own videos.`}
					</Text>
				</HStack>
			</Stack>
		</footer>
	);
};
